module.exports = __webpack_public_path__ + "static/img/sequence-boterham-min.29a1e51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/sequence-boterham-min.png
// module id = 672
// module chunks = 64